import * as moment from 'moment';
import { Moment } from 'moment';

export type CarrierSyncStatus = 'ERROR' | 'SUCCESS' | 'IN_PROGRESS';


export class CarrierSync {
  public status: CarrierSyncStatus;
  public endedAt: Moment;

  static fromDto(dto: any): CarrierSync {
    if (!dto) {
      return null;
    }
    const carrierSync = new CarrierSync();
    carrierSync.status = dto.status;
    carrierSync.endedAt = moment(dto.endedAt);
    return carrierSync;
  }

  public hasEnded(): boolean {
    return this.status === 'ERROR' || this.status === 'SUCCESS';
  }
}
